module.exports = __webpack_public_path__ + "img/iso9001.60f06fd6.png";